import React, { useCallback, useMemo, useState } from "react";
import { StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { ToastContext } from "./ToastContext";
import { ToastItem } from "./ToastItem";

export type ToastType = {
  id: string;
  message: string | React.ReactNode | React.ReactNode[];
  type: "success" | "error";
  rightText?: string | React.ReactElement;
};

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const [toastList, setToastList] = useState<ToastType[]>([]);

  const showToast = useCallback(function showToast(
    toast: Omit<ToastType, "id">,
  ) {
    const id = Math.random().toString(16).slice(-6);
    return setToastList((toastList) => [...toastList, { id, ...toast }]);
  }, []);

  const onRemove = useCallback(function onRemove(id: string) {
    setToastList((toastList) => toastList.filter((t) => t.id !== id));
  }, []);

  const value = useMemo(() => {
    return { showToast };
  }, [showToast]);

  const insets = useSafeAreaInsets();
  return (
    <ToastContext.Provider value={value}>
      {children}

      {toastList.length > 0 && (
        <View
          pointerEvents="box-none"
          paddingExtraLarge
          style={[
            S.toastWrapper,
            {
              paddingBottom: styleConstants.spacingExtraLarge + insets.bottom,
              // backgroundColor: "red",
            },
          ]}
        >
          {toastList.map((toast) => {
            return (
              <ToastItem key={toast.id} toast={toast} onRemove={onRemove} />
            );
          })}
        </View>
      )}
    </ToastContext.Provider>
  );
};

const S = StyleSheet.create({
  toastWrapper: {
    position: "absolute",
    left: 0,
    bottom: 0,
    right: 0,
  },
});
